import { ButtonTertiary } from "components/Atoms/Button";
import React from "react";
import { Message } from "semantic-ui-react";

interface LinkedArtistToUserPanelMessageProps {
  selected: number;
  total: number;
  environment: server.dto.Environments;
  onAllowAccessToAllArtists: () => void;
}

export const LinkedArtistToUserPanelMessage = (props: LinkedArtistToUserPanelMessageProps) => {
  if (props.environment === "external" && props.selected === 0) {
    return <Message color="red">
      {RESX.SoUser.NoAccessToArtists}
    </Message>
  }

  if (props.environment === "internal" && props.selected === 0) {
    return <Message color="green">
      {RESX.SoUser.ThisUserHasAccessToAllArtists}
    </Message>
  }

  const messageClassName = props.environment === "internal" ? "flex justify-space-between align-center" : "";

  return <Message className={messageClassName} color="blue">
    <span>{props.selected} / {props.total} {site.currentEnvironment.functionGroups.artist.plural}</span>
    {props.environment === "internal" && <ButtonTertiary
      label={RESX.SoUser.AllowAccessToAllArtists}
      onClick={props.onAllowAccessToAllArtists}
    />}
  </Message>
}
